module.exports = __webpack_public_path__ + "img/car-oil.227a5a15.png";